import {DeviceEventPaginationResponse} from "contracts/holotrak/deviceEvent";
import {Trip} from "contracts/holotrak/trip";
import {ITripRequest} from "contracts/ITripRequest";
import {losantApi} from "./index";

export const tripsApi = losantApi.injectEndpoints({
    endpoints: (builder) => ({
        getDeviceTrips: builder.query<Trip[], ITripRequest>({
            query: (tripRequest) => {
                return {
                    url: `/trips/${tripRequest.deviceId}?limit=${tripRequest.limit}&offset=${tripRequest.offset}&startDateRange=${tripRequest.startDateRange}&endDateRange=${tripRequest.endDateRange}`,
                    method: "get",
                };
            }
        }),
        getDeviceEvents: builder.query<DeviceEventPaginationResponse, ITripRequest>({
            query: (tripRequest) => {
                const params = new URLSearchParams({
                    limit: tripRequest.limit.toString(),
                    offset: tripRequest.offset.toString(),
                    startDateRange: tripRequest.startDateRange.format('YYYY-MM-DD'),
                    endDateRange: tripRequest.endDateRange.format('YYYY-MM-DD'),
                });
                if (tripRequest.filter) {
                    params.append('filter', tripRequest.filter);
                }

                return {
                    url: `/event-log/${tripRequest.deviceId}?${params.toString()}`,
                    method: "get",
                };
            }
        })
    })
});

export const {
    useGetDeviceTripsQuery,
    useLazyGetDeviceTripsQuery,
    useGetDeviceEventsQuery,
    useLazyGetDeviceEventsQuery,
} = tripsApi;
